import firebase from "firebase";

const getMilliseconds = (timestamp: firebase.firestore.Timestamp) => {
	return timestamp.seconds * 1000 + timestamp.nanoseconds / 10000000;
};

export default getMilliseconds;
